export enum LivrablePrincipal {
  REFERENTIEL_METIER = 'Référentiel Métier',
  PARCOURS_CROISEMENT = 'Parcours & Croisement',
  MODULARISATION = 'Modularisation',
  SCENARISATION = 'Scénarisation',
}
